export default __webpack_public_path__ + "0671ce5.png";